import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 gap-2" }
const _hoisted_2 = { class: "col-span-2 flex flex-col" }
const _hoisted_3 = { class: "relative flex items-center" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "col-span-2 flex gap-2" }
const _hoisted_6 = { class: "basis-1/2 flex flex-col" }
const _hoisted_7 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_8 = { class: "relative inline-block p-2 group" }
const _hoisted_9 = { class: "mr-2 border border-next p-1" }
const _hoisted_10 = { class: "mr-1" }
const _hoisted_11 = { class: "basis-1/2 flex flex-col" }
const _hoisted_12 = { class: "col-start-1 flex flex-col" }
const _hoisted_13 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_14 = { class: "text-sm border rounded-sm p-1" }
const _hoisted_15 = { class: "ml-2" }
const _hoisted_16 = { class: "flex flex-col" }
const _hoisted_17 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_18 = { class: "text-sm border rounded-sm p-1" }
const _hoisted_19 = { class: "ml-2" }
const _hoisted_20 = { class: "flex flex-col" }
const _hoisted_21 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_22 = { class: "text-sm border rounded-sm p-1" }
const _hoisted_23 = { class: "ml-2" }
const _hoisted_24 = { class: "flex flex-col" }
const _hoisted_25 = { class: "col-span-2 flex flex-col" }
const _hoisted_26 = { class: "flex gap-2" }
const _hoisted_27 = ["max"]
const _hoisted_28 = ["min"]
const _hoisted_29 = { class: "col flex flex-col" }
const _hoisted_30 = { class: "flex justify-end" }
const _hoisted_31 = { class: "flex justify-end pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiselectOption = _resolveComponent("MultiselectOption")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, { backdrop: true }, {
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "font-bold pb-2" }, "Ricerca", -1)),
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ricerca.text) = $event)),
              placeholder: "Cerca",
              class: "pr-2 py-2 pl-11 bg-next-gray-md w-full"
            }, null, 512), [
              [_vModelText, _ctx.ricerca.text]
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("i", { class: "icon-lente absolute left-0 ml-3" }, null, -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "font-bold pb-2" }, "Settore commerciale", -1)),
          _createVNode(_component_VueMultiselect, {
            searchable: true,
            loading: _ctx.settoriAutocomplete.isLoading,
            "internal-search": false,
            trackBy: "descrizione",
            label: "descrizione",
            onSearchChange: _ctx.settoriAutocomplete.search,
            modelValue: _ctx.settoriAutocomplete.selection,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.settoriAutocomplete.selection) = $event)),
            options: _ctx.settoriAutocomplete.options,
            multiple: true,
            "close-on-select": false,
            "clear-on-select": false,
            class: "next-vue-multiselect",
            placeholder: "Settore commerciale",
            deselectLabel: "Deseleziona",
            selectedLabel: "Selezionato",
            selectLabel: "Seleziona"
          }, {
            noResult: _withCtx(() => _cache[15] || (_cache[15] = [
              _createTextVNode("Nessun elemento trovato.")
            ])),
            noOptions: _withCtx(() => _cache[16] || (_cache[16] = [
              _createTextVNode("Digita per cercare")
            ])),
            tag: _withCtx(({ option, remove }) => [
              _createVNode(_component_MultiselectOption, {
                onRemove: ($event: any) => (remove(option))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(option.descrizione), 1)
                ]),
                _: 2
              }, 1032, ["onRemove"])
            ]),
            _: 1
          }, 8, ["loading", "onSearchChange", "modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "font-bold pb-2" }, "Business Unit", -1)),
            _createVNode(_component_VueMultiselect, {
              searchable: true,
              loading: _ctx.buAutocomplete.isLoading,
              "internal-search": false,
              trackBy: "id",
              label: "label",
              onSearchChange: _ctx.buAutocomplete.search,
              modelValue: _ctx.buAutocomplete.selection,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.buAutocomplete.selection) = $event)),
              options: _ctx.buAutocomplete.options,
              multiple: true,
              "close-on-select": false,
              "clear-on-select": false,
              class: "next-vue-multiselect",
              placeholder: "Business Unit",
              deselectLabel: "Deseleziona",
              selectedLabel: "Selezionato",
              selectLabel: "Seleziona"
            }, {
              tag: _withCtx(({ option, remove }) => [
                _createVNode(_component_MultiselectOption, {
                  onRemove: ($event: any) => (remove(option))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(option.label || ' '), 1),
                    _createElementVNode("span", null, _toDisplayString(option.nome), 1)
                  ]),
                  _: 2
                }, 1032, ["onRemove"])
              ]),
              option: _withCtx(({ option, props }) => [
                _createElementVNode("span", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(option.label), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(option.nome), 1)
                ])
              ]),
              _: 1
            }, 8, ["loading", "onSearchChange", "modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "font-bold pb-2" }, "Stato", -1)),
            _createVNode(_component_VueMultiselect, {
              searchable: true,
              "internal-search": true,
              trackBy: "id",
              label: "label",
              modelValue: _ctx.stato_select,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.stato_select) = $event)),
              options: _ctx.stato_options,
              "close-on-select": true,
              "clear-on-select": true,
              class: "next-vue-multiselect-single",
              placeholder: "Stato"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "font-bold pb-2" }, "Responsabili", -1)),
          _createVNode(_component_VueMultiselect, {
            searchable: true,
            loading: _ctx.responsabileAutocomplete.isLoading,
            "internal-search": false,
            trackBy: "id",
            label: "nome",
            onSearchChange: _ctx.responsabileAutocomplete.search,
            modelValue: _ctx.responsabileAutocomplete.selection,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.responsabileAutocomplete.selection) = $event)),
            options: _ctx.responsabileAutocomplete.options,
            multiple: true,
            "close-on-select": false,
            "clear-on-select": false,
            class: "next-vue-multiselect",
            placeholder: "Responsabili",
            deselectLabel: "Deseleziona",
            selectedLabel: "Selezionato",
            selectLabel: "Seleziona"
          }, {
            noResult: _withCtx(() => _cache[20] || (_cache[20] = [
              _createTextVNode("Nessun elemento trovato.")
            ])),
            noOptions: _withCtx(() => _cache[21] || (_cache[21] = [
              _createTextVNode("Digita per cercare")
            ])),
            tag: _withCtx(({ option, remove }) => [
              _createVNode(_component_MultiselectOption, {
                onRemove: ($event: any) => (remove(option))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(option.bu_label || ' '), 1),
                  _createElementVNode("span", null, _toDisplayString(option.name), 1)
                ]),
                _: 2
              }, 1032, ["onRemove"])
            ]),
            option: _withCtx(({ option }) => [
              _createElementVNode("span", null, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(option.bu_label), 1),
                _createElementVNode("span", _hoisted_15, _toDisplayString(option.name), 1)
              ])
            ]),
            _: 1
          }, 8, ["loading", "onSearchChange", "modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "font-bold pb-2" }, "Presentazione", -1)),
          _createVNode(_component_VueMultiselect, {
            modelValue: _ctx.presentazioneAutocomplete.selection,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.presentazioneAutocomplete.selection) = $event)),
            options: _ctx.presentazioneAutocomplete.options,
            multiple: true,
            onSearchChange: _ctx.presentazioneAutocomplete.search,
            "close-on-select": false,
            placeholder: "Presentazione",
            deselectLabel: "Deseleziona",
            selectedLabel: "Selezionato",
            selectLabel: "Seleziona",
            class: "next-vue-multiselect",
            "track-by": "id",
            label: "name"
          }, {
            noResult: _withCtx(() => _cache[23] || (_cache[23] = [
              _createTextVNode("Nessun elemento trovato.")
            ])),
            noOptions: _withCtx(() => _cache[24] || (_cache[24] = [
              _createTextVNode("Digita per cercare")
            ])),
            tag: _withCtx(({ option, remove }) => [
              _createVNode(_component_MultiselectOption, {
                onRemove: ($event: any) => (remove(option))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(option.bu_label || ' '), 1),
                  _createElementVNode("span", null, _toDisplayString(option.name), 1)
                ]),
                _: 2
              }, 1032, ["onRemove"])
            ]),
            option: _withCtx(({ option }) => [
              _createElementVNode("span", null, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(option.bu_label), 1),
                _createElementVNode("span", _hoisted_19, _toDisplayString(option.name), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "onSearchChange"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "font-bold pb-2" }, "Account", -1)),
          _createVNode(_component_VueMultiselect, {
            searchable: true,
            loading: _ctx.accountsAutocomplete.isLoading,
            "internal-search": false,
            trackBy: "id",
            label: "nome",
            onSearchChange: _ctx.accountsAutocomplete.search,
            modelValue: _ctx.accountsAutocomplete.selection,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.accountsAutocomplete.selection) = $event)),
            options: _ctx.accountsAutocomplete.options,
            multiple: true,
            "close-on-select": false,
            "clear-on-select": false,
            class: "next-vue-multiselect",
            placeholder: "Account",
            deselectLabel: "Deseleziona",
            selectedLabel: "Selezionato",
            selectLabel: "Seleziona"
          }, {
            noResult: _withCtx(() => _cache[26] || (_cache[26] = [
              _createTextVNode("Nessun elemento trovato.")
            ])),
            noOptions: _withCtx(() => _cache[27] || (_cache[27] = [
              _createTextVNode("Digita per cercare")
            ])),
            tag: _withCtx(({ option, remove }) => [
              _createVNode(_component_MultiselectOption, {
                onRemove: ($event: any) => (remove(option))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(option.bu_label || ' '), 1),
                  _createElementVNode("span", null, _toDisplayString(option.name), 1)
                ]),
                _: 2
              }, 1032, ["onRemove"])
            ]),
            option: _withCtx(({ option }) => [
              _createElementVNode("span", null, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(option.bu_label), 1),
                _createElementVNode("span", _hoisted_23, _toDisplayString(option.name), 1)
              ])
            ]),
            _: 1
          }, 8, ["loading", "onSearchChange", "modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "font-bold pb-2" }, "Contatti", -1)),
          _createVNode(_component_VueMultiselect, {
            searchable: true,
            loading: _ctx.contattoAutocomplete.isLoading,
            "internal-search": false,
            trackBy: "id",
            label: "nome",
            onSearchChange: _ctx.contattoAutocomplete.search,
            modelValue: _ctx.contattoAutocomplete.selection,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.contattoAutocomplete.selection) = $event)),
            options: _ctx.contattoAutocomplete.options,
            multiple: true,
            "close-on-select": false,
            "clear-on-select": false,
            class: "next-vue-multiselect",
            placeholder: "Contatti",
            deselectLabel: "Deseleziona",
            selectedLabel: "Selezionato",
            selectLabel: "Seleziona"
          }, {
            noResult: _withCtx(() => _cache[29] || (_cache[29] = [
              _createTextVNode("Nessun elemento trovato.")
            ])),
            noOptions: _withCtx(() => _cache[30] || (_cache[30] = [
              _createTextVNode("Digita per cercare")
            ])),
            tag: _withCtx(({ option, remove }) => [
              _createVNode(_component_MultiselectOption, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(option.nome) + " " + _toDisplayString(option.cognome), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["loading", "onSearchChange", "modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _cache[32] || (_cache[32] = _createElementVNode("div", { class: "font-bold pb-2" }, "Ultimo contatto", -1)),
          _createElementVNode("div", _hoisted_26, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ricerca.ultimo_contatto_da) = $event)),
              max: _ctx.ricerca.ultimo_contatto_a,
              type: "date",
              class: "p-2 bg-next-gray-md w-full"
            }, null, 8, _hoisted_27), [
              [_vModelText, _ctx.ricerca.ultimo_contatto_da]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.ricerca.ultimo_contatto_a) = $event)),
              min: _ctx.ricerca.ultimo_contatto_da,
              type: "date",
              class: "p-2 bg-next-gray-md w-full"
            }, null, 8, _hoisted_28), [
              [_vModelText, _ctx.ricerca.ultimo_contatto_a]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _cache[35] || (_cache[35] = _createElementVNode("div", { class: "font-bold pb-2" }, "Nazionalità", -1)),
          _createVNode(_component_VueMultiselect, {
            searchable: true,
            loading: _ctx.nazioniAutocomplete.isLoading,
            "internal-search": false,
            trackBy: "id",
            label: "nome",
            onSearchChange: _ctx.nazioniAutocomplete.search,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.sanitizeNationality($event))),
            "model-value": _ctx.nazioniAutocomplete.selection,
            options: _ctx.nazioniAutocomplete.options,
            multiple: true,
            "close-on-select": false,
            "clear-on-select": false,
            class: "next-vue-multiselect-single",
            placeholder: "Nazioni",
            deselectLabel: "Deseleziona",
            selectedLabel: "Selezionato",
            selectLabel: "Seleziona"
          }, {
            noResult: _withCtx(() => _cache[33] || (_cache[33] = [
              _createTextVNode("Nessun elemento trovato.")
            ])),
            noOptions: _withCtx(() => _cache[34] || (_cache[34] = [
              _createTextVNode("Digita per cercare")
            ])),
            tag: _withCtx(({ option, remove }) => [
              _createVNode(_component_MultiselectOption, {
                onRemove: ($event: any) => (remove(option))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(option.nome), 1)
                ]),
                _: 2
              }, 1032, ["onRemove"])
            ]),
            _: 1
          }, 8, ["loading", "onSearchChange", "model-value", "options"])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_NextButton, {
            variant: "outline-secondary",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('reject'))),
            class: "col-start-3 py-2 px-4"
          }, {
            default: _withCtx(() => _cache[36] || (_cache[36] = [
              _createTextVNode(" Chiudi ")
            ])),
            _: 1
          }),
          _createVNode(_component_NextButton, {
            variant: "primary",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('confirm', _ctx.ricerca))),
            class: "ml-4 py-2 px-4"
          }, {
            default: _withCtx(() => _cache[37] || (_cache[37] = [
              _createTextVNode(" Cerca ")
            ])),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}